import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { AuthService } from '@auth0/auth0-angular';
import { PersonaService } from 'src/app/services/persona.service';
import { StepperService } from 'src/app/services/stepper.service';
@Component({
  selector: 'app-estado-situacion-stepper',
  templateUrl: './estado-situacion-stepper.component.html',
  styleUrls: ['./estado-situacion-stepper.component.css']
})
export class EstadoSituacionStepperComponent implements OnInit, AfterViewInit {
  @ViewChild('stepper')
  private stepper!: MatStepper;
  currentStep: number = 0;
  activos: any[] = [];
  userId: any = 0;
  
  constructor(
    public auth: AuthService,
    private personaService: PersonaService,
    private stepperService: StepperService
  ) {
    this.personaService.setPersona();
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    this.stepperService.setStepper(this.stepper);
  }

}
